export const PRIVACY = 1;
export const SECURITY = 2;
export const TERMS_CONDITIONS = 3;
export const TCPA = 4;
